import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-remove-squere-btn',
  templateUrl: './remove-squere-btn.component.html',
  styleUrls: ['./remove-squere-btn.component.scss']
})
export class RemoveSquereBtnComponent {

  @Output() onClick = new EventEmitter();
  @Input() disabled = false;

}
